import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import BlogSingleDetailsOne from '../../components/blog-components/BlogSingleDetailsOne';
import FooterOne from '../../common/footer/FooterOne';

const BlogSingleOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Blog Single 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Blog Single 1"
        />
        
        <BlogSingleDetailsOne />
        
        <FooterOne />
        </>
    )
}
    
export default BlogSingleOne;